import styled from 'styled-components';
import Link from 'next/link';
import { Typography } from '../../ui/Typography';
import { transitionStyles } from '../../../styled/common';
import { Breakpoints } from '../../../styled/constants';

export const CardContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
  border-radius: 14px;
  padding: 15px 20px;
  background-color: ${({ theme }) => theme.colors.background.tertiary};
  border: 1px solid transparent;
  ${transitionStyles('border-color')}

  &:hover {
    border-color: ${({ theme }) => theme.colors.systemColors.blue};
  }

  @media (max-width: ${Breakpoints.smallDesktop}px) {
    border: none;
    margin: 0 40px;
  }

  @media (max-width: ${Breakpoints.tablet}px) {
    margin: 0;
  }
`;

export const Title = styled(Typography).attrs({ tag: 'title_4_new' })``;

export const ContentWrapper = styled.div`
  display: flex;
  gap: 10px;
  align-items: center;
`;

export const ImageWrapper = styled.div`
  width: 70px;
  height: 70px;
  flex-shrink: 0;
  border-radius: 7px;
  overflow: hidden;

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
`;

export const InfoColumn = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 2px;
`;

export const Price = styled(Typography).attrs({ tag: 'body_3' })``;

export const Details = styled(Typography).attrs({ tag: 'body_2' })``;

export const Location = styled(Typography).attrs({ tag: 'body_2' })``;

export const AdNumber = styled(Typography).attrs({ tag: 'body_2' })`
  color: ${({ theme }) => theme.colors.text.secondary};
`;

export const FooterLink = styled(Link)`
  display: block;
  padding: 0 15px;
  text-align: center;
  color: ${({ theme }) => theme.colors.systemColors.blue};
  text-decoration: underline;
  font-size: 15px;
  cursor: pointer;
  height: 30px;
  line-height: 30px;

  @media (max-width: ${Breakpoints.smallDesktop}px) {
    text-align: left;
    padding: 0;
  }
`;
